import styled from 'styled-components';
import { IThemeProvider } from '../../../../styles/theme';

export const ReportsNestedTableCont = styled.div`
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  width: 100%;
  ${({ theme }: IThemeProvider) => `
    padding: 0 35px 0 ${theme.layout.spacing.tera};
    margin: 32px 0 0 0;
  `};
`;
